export default __webpack_public_path__ + "static/media/dentsply-logo.e9835a02.svg";